import { siteUrl } from "src/api/config";

const REDIRECT_SCHEME = "supplyapp://auth";

class AuthManager {
  private onAuth?: () => void;
  private redirectHandled = false;

  async init(onAuth: () => void) {
    this.onAuth = onAuth;

    if (this.isPWA()) {
      this.initWeb();
    }
  }

  // =========================
  // PLATFORM DETECTION
  // =========================

  // private isPWA() {
  //   return typeof window !== "undefined" && !!(window as any).strapiUser;
  // }

  private isPWA() {
    return typeof window !== "undefined" && "strapiUser" in window;
  }

  // =========================
  // NATIVE (iOS / Android)
  // =========================

  // private async initNative() {
  //   App.addListener("appUrlOpen", ({ url }) => {
  //     this.handleNativeRedirect(url);
  //   });

  //   const launch = await App.getLaunchUrl();
  //   if (launch?.url) {
  //     await this.handleNativeRedirect(launch.url);
  //     return;
  //   }

  //   App.addListener("resume", async () => {
  //     await this.handleResume();
  //   });

  //   const token = await this.getToken();

  //   if (token && await this.checkToken(token)) {
  //     this.onAuth?.();
  //     return;
  //   }

  //   await this.startNativeLogin();
  // }

  // private async startNativeLogin() {
  //   const state = crypto.randomUUID();

  //   await Preferences.set({ key: "oauth_state", value: state });

  //   const redirectUri = encodeURIComponent(REDIRECT_SCHEME);

  //   const url =
  //     `${siteUrl}/mobile/auth/start?redirectUri=${redirectUri}&state=${state}`;

  //   await Browser.open({ url });
  // }

  // private async handleNativeRedirect(url: string) {
  //   if (!url.startsWith(REDIRECT_SCHEME)) return;
  //   if (this.redirectHandled) return;

  //   this.redirectHandled = true;

  //   await Browser.close();

  //   const parsed = new URL(url);
  //   const code = parsed.searchParams.get("code");
  //   const state = parsed.searchParams.get("state");

  //   const { value: savedState } = await Preferences.get({ key: "oauth_state" });

  //   if (!code || state !== savedState) {
  //     await Preferences.remove({ key: "oauth_state" });
  //     return;
  //   }

  //   try {
  //     const res = await fetch(`${siteUrl}/mobile/token`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ code }),
  //     });

  //     const data = await res.json();

  //     await SecureStoragePlugin.set({
  //       key: "accessToken",
  //       value: data.accessToken,
  //     });

  //     await Preferences.remove({ key: "oauth_state" });

  //     this.onAuth?.();
  //   } catch (e) {
  //     console.error("Token exchange failed", e);
  //   }
  // }

  // private async handleResume() {
  //   const token = await this.getToken();

  //   if (!token) return;

  //   const valid = await this.checkToken(token);

  //   if (!valid) {
  //     await SecureStoragePlugin.remove({ key: "accessToken" });
  //     await this.startNativeLogin();
  //   }
  // }

  // =========================
  // WEB (PWA)
  // =========================

  // private async initWeb() {
  //   // 👉 если пришли с OAuth
  //   if (this.isPWA() && this.isMobileAuthPage()) {
  //     this.handleWebRedirect();
  //     return;
  //   }

  //   // 👉 если есть strapiUser — всегда запускаем OAuth
  //   if (this.isPWA()) {
  //     this.startWebLogin();
  //   }
  // }

  private async initWeb() {
    // 👉 если пришли с OAuth
    if (this.isPWA() && this.isMobileAuthPage()) {
      this.handleWebRedirect();
      return;
    }

    // 👉 если уже авторизовались — ничего не делаем
    // const authDone = sessionStorage.getItem("mobile_auth_done");

    // if (authDone) {
    //   this.onAuth?.();
    //   return;
    // }

    // 👉 проверяем сессию через cookie
    const valid = await this.checkSession();

    if (valid) {
      this.onAuth?.();
      return;
    }

    // 👉 первый заход → запускаем OAuth
    if (this.isPWA()) {
      this.startWebLogin();
    }
  }

  private isMobileAuthPage() {
    return window.location.pathname === "/mobile-auth";
  }

  private startWebLogin() {
    const state = crypto.randomUUID();

    sessionStorage.setItem("mobile_auth_state", state);

    const redirectUri = encodeURIComponent(
      `${window.location.origin}/mobile-auth`
    );

    window.location.href =
      `${siteUrl}/mobile/auth/start?redirectUri=${redirectUri}&state=${state}`;
  }

  // private handleWebRedirect() {
  //   const params = new URLSearchParams(window.location.search);

  //   const state = params.get("state");
  //   const savedState = sessionStorage.getItem("mobile_auth_state");

  //   if (state !== savedState) {
  //     console.error("Invalid state");
  //     return;
  //   }

  //   sessionStorage.removeItem("mobile_auth_state");

  //   // 👉 backend уже поставил cookie
  //   window.location.href = "/";
  // }

  private handleWebRedirect() {
    const params = new URLSearchParams(window.location.search);

    const state = params.get("state");
    const savedState = sessionStorage.getItem("mobile_auth_state");

    if (state !== savedState) {
      console.error("Invalid state");
      return;
    }

    sessionStorage.removeItem("mobile_auth_state");

    // 🔥 ключевая строка
    sessionStorage.setItem("mobile_auth_done", "1");

    // 👉 backend уже поставил cookie
    window.location.href = "/";
  }

  // =========================
  // SHARED
  // =========================

  // private async getToken() {
  //   try {
  //     const res = await SecureStoragePlugin.get({ key: "accessToken" });
  //     return res.value;
  //   } catch {
  //     return null;
  //   }
  // }

  // private async checkToken(token: string) {
  //   try {
  //     const res = await fetch(`${siteUrl}/mobile/check`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     return res.ok;
  //   } catch {
  //     return false;
  //   }
  // }

  private async checkSession() {
    try {
      const res = await fetch(`${siteUrl}/check`);

      return res.ok;
    } catch {
      return false;
    }
  }
}

export const authManagerWeb = new AuthManager();
